import { dataIdFromObject } from "./data-id-from-object";
import { InMemoryCache } from "@outschool/ui-apollo";

export function createMemoryCache() {
  return new InMemoryCache({
    dataIdFromObject,
    possibleTypes,
    typePolicies: {
      Sender: {
        keyFields: false,
        merge: true,
      },
    },
  });
}

const possibleTypes: Record<string, string[]> = {
  IMessage: ["Message", "PrivateClassMessage", "ClassPostComment"],
  IMessageThread: [
    "MessageThread",
    "PrivateClassThread",
    "ClassPostCommentThread",
  ],
  BaseEnrollment: ["Enrollment", "GiftEnrollment"],
  INotification: [
    "ClassPostNotification",
    "ClubNotification",
    "PrivateClassMessageNotification",
    "AssignmentNotification",
  ],
};
